import styled from 'styled-components';
import { theme } from '../../../theme';

export const WrapForButton = styled('div')`
  margin-top:  ${theme.offsets.md};

`